const routeKeys = [
  { key: "nav.emtay", href: "/#top" },
  { key: "nav.services", route: "/services" },
  { key: "nav.ourmethod", route: "/method" },
  { key: "nav.contact", route: "/contact" },
];

export const routeKeyMap = {
  emtay: "nav.emtay",
  services: "nav.services",
  ourmethod: "nav.ourmethod",
  contact: "nav.contact",
};

export default routeKeys;
